import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default action('toggleExpansion')(select({
    store: function () { return store; },
})(function toggleExpansion(state) {
    state.store.isExpansionOpen = !state.store.isExpansionOpen;
}));
//# sourceMappingURL=toggleExpansion.js.map